module.exports = __webpack_public_path__ + "img/1697158339740-WhatsApp Image 2023-10-13 at 08.50.15.jpeg.016a5ea3.webp";